<rask-map-popup-content [abort]="abort" [canEdit]="canEdit" [edit]="edit" [delete]="askRemoveCurrentGraphic">
  <ng-container header>{{ 'KARTGEOMETRI_POPUP_RUBRIK' | translate:{'subtyp1': kartgeometri.subtyp1 } }}</ng-container>
  @if (ready) {
    <form [formGroup]="form">
      @if (stateMatrix.showYta) {
        <rask-input
          class="col-6"
          [readonly]="true"
          value="{{ figurAreal | number:'1.2-2' }} {{ figurArealUnit }}"
          label="{{'KARTGEOMETRI_POPUP_KARTGEOMETRI_AREAL' | translate}}">
        </rask-input>
      }
      @if (stateMatrix.showYta && canEdit) {
        <rask-button-stack class="col-6 align-left ms-0 ps-0 pe-0">
          <rask-action-button (click)="addArea()" icon="far fa-plus">Lägg till delyta</rask-action-button>
          <rask-action-button (click)="cutArea()" icon="far fa-crop-alt">Beskär</rask-action-button>
        </rask-button-stack>
      }
      <rask-selector
        class="col-12"
        [required]="true"
        label="'{{'KARTGEOMETRI_POPUP_KARTGEOMETRI_TYP' | translate}}"
        formControlName="subtyp2"
        [values]="subtypes2"
        (change)="clearKarttext($event)">
      </rask-selector>
      @if (subtypes && stateMatrix.showSubtyp3Selector) {
        <rask-selector
          class="col-12"
          [required]="true"
          label="{{stateMatrix.labelConstantSubtyp3 | translate}}"
          [reverseLookup]="false"
          formControlName="subtyp3"
          [values]="subtypes">
        </rask-selector>
      }
      @if (stateMatrix.showTillganglighetsklassSelector) {
        <rask-selector
          class="col-12"
          label="{{'KARTGEOMETRI_POPUP_TILLGANGLIGHETSKLASS' | translate}}"
          formControlName="tillganglighetsklass"
          [values]="kartgeometriBasdata.tillganglighetsklasser">
        </rask-selector>
      }
      @if (stateMatrix.showPlockhuggning) {
        <rask-radiobutton-group
          class="col-12"
          label="{{'KARTGEOMETRI_POPUP_PLOCKHUGGNING' | translate}}"
          [buttons]="plockhuggningButtons"
          formControlName="hansynAtgardTyp">
        </rask-radiobutton-group>
      }
      @if (stateMatrix.showLangd) {
        <rask-input
          [readonly]="true"
          value="{{ kartgeometri.langd | number: '1.0-0' }}"
          label="{{'KARTGEOMETRI_POPUP_LANGD' | translate}}">
        </rask-input>
      }
      @if (stateMatrix.showKarttext) {
        <rask-textarea
          formControlName="karttext"
          class="col-12"
          [maxlength]="50"
          [rows]="3"
          [label]="stateMatrix.karttextLabel">
        </rask-textarea>
      }
      @if (stateMatrix.showAnteckning) {
        <rask-textarea
          class="col-12"
          label="{{'KARTGEOMETRI_POPUP_ANTECKNING' | translate}}"
          [rows]="3"
          formControlName="anteckning">
        </rask-textarea>
      }
    </form>
  }
</rask-map-popup-content>
